import React from "react";
import dayjs from "dayjs";

interface FaqMobilePreviewPageProps {
  data: any; // your preview data
  onClose: () => void; // function to close preview
}

const FaqMobilePreviewPage: React.FC<FaqMobilePreviewPageProps> = ({
  data,
}) => {
  return (
    <div style={styles.frame}>
      {/* Notch */}
      <div style={styles.notch}>
        <div style={styles.speaker}></div>
        <div style={styles.camera}></div>
      </div>

      {/* Scrollable container */}
      <div style={styles.scrollableArea} className="mobile-scroll">
        {/* Top colored area */}
        <div style={styles.topArea}>
          <div style={styles.topRow}>
            <span style={styles.hamburger}>☰</span>
          </div>
          <div style={styles.logoWrapper}>
            <img
              src="/images/MobileORLogo.png"
              alt="App Logo"
              style={styles.appLogo}
            />
          </div>
        </div>

        {/* White content area */}
        <div style={styles.screen}>
          <span style={styles.closeIcon}>✕</span>


          {/* Mobile Inner Content */}
          <div style={styles.previewContainer}>
            {/* Campaign Name */}
            <div style={styles.campaignName}>
              {data.question || "Question"}
            </div>

            <div style={styles.divider}></div>

            {data.notificationType?.includes("email") && (
              <>
                {data.emailSubject && (
                  <p style={styles.subjectText}>{data.emailSubject}</p>
                )}

                {data.emailText && (
                  <p style={styles.emailText}>{data.emailText}</p>
                )}
              </>
            )}
            <div style={styles.scrollInner} className="custom-scrollbar">
              <div
                className="description-preview"
                style={styles.description}

                dangerouslySetInnerHTML={{ __html: data.answer || "Answer" }}
              ></div>
            </div>
          </div>
        </div>
      </div>
      {/* Custom Scrollbar */}
      <style>
        {`
          .custom-scrollbar {
            scrollbar-width: thin;
            scrollbar-color: #b0b0b0 transparent;
          }
          .custom-scrollbar::-webkit-scrollbar {
            width: 6px;
          }
          .custom-scrollbar::-webkit-scrollbar-thumb {
            background-color: #b0b0b0;
            border-radius: 10px;
          }
          .custom-scrollbar::-webkit-scrollbar-thumb:hover {
            background-color: #8c8c8c;
          }
        `}
      </style>
    </div>
  );
};

export default FaqMobilePreviewPage;

const styles: { [key: string]: React.CSSProperties } = {
  frame: {
    width: "320px",
    height: "667px",
    border: "14px solid #222",
    borderRadius: "40px",
    overflow: "hidden",
    backgroundColor: "#fff",
    boxShadow: "0 10px 25px rgba(0,0,0,0.2)",
    position: "relative",
    display: "flex",
    flexDirection: "column",
  },
  scrollableArea: {
    flex: 1,
    overflowY: "auto",
    scrollbarWidth: "none",
    msOverflowStyle: "none",
    WebkitOverflowScrolling: "touch",
  },
  notch: {
    position: "absolute",
    top: 0,
    left: "50%",
    transform: "translateX(-50%)",
    width: "200px",
    height: "15px",
    backgroundColor: "#222",
    borderBottomLeftRadius: "20px",
    borderBottomRightRadius: "20px",
    display: "flex",
    justifyContent: "center",
    alignItems: "flex-start",
    gap: "8px",
    padding: "4px 8px",
    zIndex: 3,
    boxSizing: "border-box",
  },
  speaker: {
    width: "40px",
    height: "4px",
    backgroundColor: "white",
    borderRadius: "2px",
  },
  camera: {
    width: "8px",
    height: "10px",
    backgroundColor: "white",
    borderRadius: "50%",
    boxShadow: "0 0 1px #000",
    alignSelf: "flex-end",
  },
  topArea: {
    backgroundColor: "#63555B",
    paddingTop: "36px",
    paddingBottom: "20px",
    display: "flex",
    flexDirection: "column",
    alignItems: "center",
    position: "relative",
    zIndex: 1,
  },
  topRow: {
    width: "100%",
    display: "flex",
    justifyContent: "flex-start",
    paddingLeft: "20px",
  },
  hamburger: {
    fontSize: "0.95rem",
    color: "white",
  },
  logoWrapper: {
    marginBottom: "18px",
  },
  appLogo: {
    height: "80px",
    objectFit: "contain",
  },
  screen: {
    padding: "1rem 1.5rem 1rem 1rem",
    backgroundColor: "#fff",
    borderTopLeftRadius: "30px",
    borderTopRightRadius: "30px",
    marginTop: "-20px",
    boxSizing: "border-box",
    position: "relative",
    zIndex: 2,
  },
  closeIcon: {
    position: "absolute",
    top: "12px",
    right: "16px",
    fontSize: "1rem",
    color: "#999",
    cursor: "default",
    zIndex: 5,
  },
  previewContainer: {
    display: "flex",
    flexDirection: "column",
    alignItems: "center",
    textAlign: "center",
    padding: "16px",
    fontFamily: "'Segoe UI', 'Roboto', 'Helvetica Neue', sans-serif",
  },
  campaignName: {
    fontSize: "16px",
    fontWeight: 600,
    color: "#333",
    marginBottom: "4px",
    alignSelf: "flex-start",
    textAlign: "left",
    width: "100%",
  },

  divider: {
    width: "100%",
    height: "2px",
    backgroundColor: "#C19763",
    margin: "10px 0 16px 0",
    borderRadius: "2px",
  },
  description: {
    fontSize: "13px",
    color: "#555",
    lineHeight: "1.5",
    textAlign: "left",
  },

  emailText: {
    fontSize: "13px",
    color: "#555",
    marginBottom: "14px",
    alignSelf: "flex-start",
    textAlign: "left",
    width: "100%",
  },
  subjectText: {
    fontSize: "14px",
    color: "#333",
    fontWeight: "600",
    marginBottom: "14px",
    alignSelf: "flex-start",
    textAlign: "left",
    width: "100%",
  },
};

